<br><br>
<div class="container">
    <div class="row">
        <div class="col text-center">
            <h2>We re-sent you an confirmation email</h2>
            <h5>Please check your email to confirmation your account</h5>
		<a class="btn btn-secondary text-white" style="border-radius:0;border:none;background-color:#1cd5db"
		[routerLink]="['']" 
		routerLinkActive="active">
		<i class="fas fa-home"></i> Go to home page</a>
        </div>
    </div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
